// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {reduxForm} from 'redux-form'
import Checkbox from '@material-ui/core/Checkbox'

import {changeCheckAllBoxState} from '../../../actions/table'

import './index.css'

class TableHeaders extends Component {
  handleOnChange = () => {
    const {table} = this.props
    if (table.checkAll && table.keepChecked) {
      this.props.changeCheckAllBoxState(false, false)
    } else {
      this.props.changeCheckAllBoxState(true, true)
    }
  }

  render () {
    const {handleSubmit, checkBoxes, tableHeaders, table, reset} = this.props
    return (
      <div className='col-md-12'>
        <form className={`tr table-headers-form row`} onSubmit={(e) => {handleSubmit(e); reset()}}>
          {checkBoxes &&
            <div className='th col-1'>
              <Checkbox onChange={this.handleOnChange} checked={table.keepChecked}/>
            </div>
          }
          {tableHeaders}
        </form>
      </div>
    )
  }
}

function mapStateToProps ({table}) {
  return ({table})
}

const TableHeadersRedux = connect(mapStateToProps, {changeCheckAllBoxState})(TableHeaders)

export default reduxForm({
  form: 'tableHeaderFilter',
})(TableHeadersRedux)
